/**
 * useDeleteRoteiro — deletes an `ai_jobs` row (task='roteiros') belonging
 * to the current user. `ai_job_results` cascades via FK.
 *
 * Scoped explicitly with `.eq("user_id", profileId)` because the Clerk →
 * Supabase JWT bridge is not 100% consistent across this app — RLS would
 * silently no-op if `auth.uid()` returned a mismatched id.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSupabaseClient } from "@/lib/supabase";
import { useProfileId } from "@/features/onboarding/hooks/useProfileId";

export function useDeleteRoteiro() {
  const qc = useQueryClient();
  const { client } = useSupabaseClient();
  const { profileId } = useProfileId();

  return useMutation<void, Error, string>({
    mutationFn: async (id: string) => {
      if (!profileId) throw new Error("Sessão não pronta. Tente novamente.");
      const { error } = await client
        .from("ai_jobs")
        .delete()
        .eq("id", id)
        .eq("user_id", profileId);
      if (error) throw new Error(error.message);
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["ai_jobs"] });
      void qc.invalidateQueries({ queryKey: ["roteiros"] });
    },
  });
}
